import useAuth from '@frolight/hooks/useAuth';
import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import * as authenticationService from '@frolight/services/api/authenticationService';

const useSignOut = () => {
  const { setAuth } = useAuth();
  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  const signOut = async () => {
    try {
      const signOutAbortController = new AbortController();
      await authenticatedAPIServiceCall(
        authenticationService.signOut,
        {
          abortController: signOutAbortController,
        }
      );
    } catch (err) {
      throw err;
    } finally {
      setAuth({});
    }
  };

  return signOut;
};

export default useSignOut;
